export const OUTSOURCE_AGENT_ID = 'EXTERNAL~OutsourcingAgent';

export const ACCUSED_KEYS = {
  user: 'org.coursera.integrity.SingleUser',
  team: 'org.coursera.integrity.AccusedTeam',
};

export const COMMENT_MAX_LEN = 250;
